/* eslint-disable @typescript-eslint/no-unused-vars */
export class EntityProvider<Key = string, ClassType = any> {
    private entities = new Map<Key, ClassType>();

    constructor(private ctor: new (key: Key, ...args: any) => ClassType) {}

    public getInstance<SpecificClassType extends ClassType>(
        key: Key,
        ...args: any
    ) {
        if (!this.entities.has(key)) {
            this.entities.set(key, new this.ctor(key, ...args));
        }

        return this.entities.get(key) as SpecificClassType;
    }
}
